module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-medium.woff
// module id = tB7j
// module chunks = 0